module.exports = __webpack_public_path__ + "img/cancelround.ec3e5b83.svg";